import { Spin } from "antd";
import React, { ReactNode } from "react";
 
const ComLoading: React.FC= ({
 
}) => { 

  return (
   <div style={{width:'100%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
     <Spin spinning={true} tip="加载中..."  ></Spin>
   </div>
  );
};

export default ComLoading; 
